/**
 * Classify the GPU bottleneck from core (SM) util vs memory-controller util.
 * LLM token generation is memory-bandwidth bound: high memory util with lower core util
 * means the compute units sit idle waiting on VRAM. Returns null when idle or data is missing.
 */
export function boundLabel(
  utilPct: number | null,
  memUtilPct: number | null,
): 'memory-bound' | 'compute-bound' | null {
  if (utilPct == null || memUtilPct == null) return null;
  if (memUtilPct < 25 && utilPct < 25) return null; // idle — no meaningful bottleneck
  return memUtilPct >= utilPct ? 'memory-bound' : 'compute-bound';
}

/** Degrees Celsius of headroom before the GPU thermally throttles (slowdown). null if unknown. */
export function thermalHeadroomC(
  tempC: number | null,
  slowdownC: number | null,
): number | null {
  if (tempC == null || slowdownC == null) return null;
  return slowdownC - tempC;
}
